// extracted by mini-css-extract-plugin
export default {"currencyButton":"style_currencyButton__KbYsn","svg":"style_svg__Msavd","currencyIsShow":"style_currencyIsShow__-h4Iy"};